export default __webpack_public_path__ + "static/media/business_logistics.8433ff77.svg";